// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetHostConfigModel from '../../model/widget-host-config-model';
import WidgetHostConfigDTO from '../dto/widget-host-config-dto';
import dtoSchema from '../schemas/widget-host-config-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class WidgetHostConfigModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetHostConfigDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.name = data.name ?? undefined;
      this.hostKey = data.hostKey ?? undefined;
      this.loaderUrl = data.loaderUrl ?? undefined;
      this.allowedReferers = data.allowedReferers ?? undefined;
      this.languageIso2 = data.languageIso2 ?? undefined;
      this.locale = data.locale ?? undefined;
      this.entryPoint = data.entryPoint ?? undefined;
      this.navigation = data.navigation ?? undefined;
      this.startParameters = data.startParameters ?? undefined;
      this.apiKey = data.apiKey ?? undefined;
      this.isDebug = data.isDebug;
      this.isActive = data.isActive;
      this.textContentScope = data.textContentScope ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  name?: string;
  /**
  */
  hostKey?: string;
  /**
  */
  loaderUrl?: string;
  /**
  */
  allowedReferers?: string;
  /**
  */
  languageIso2?: string;
  /**
  */
  locale?: string;
  /**
  */
  entryPoint?: string;
  /**
  */
  navigation?: string;
  /**
  */
  startParameters?: string;
  /**
  */
  apiKey?: string;
  /**
  */
  isDebug?: boolean;
  /**
  */
  isActive?: boolean;
  /**
  */
  textContentScope?: string;

  static toModel(dto: DeepPartial<WidgetHostConfigDTO>): WidgetHostConfigModel;
  static toModel(dto: DeepPartial<WidgetHostConfigDTO> | undefined | null): WidgetHostConfigModel | undefined;
  static toModel(dto: DeepPartial<WidgetHostConfigDTO> | undefined | null): WidgetHostConfigModel | undefined {
    return dto ? new WidgetHostConfigModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetHostConfigModel> | WidgetHostConfigModel): WidgetHostConfigDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      name: unwrapped.name,
      hostKey: unwrapped.hostKey,
      loaderUrl: unwrapped.loaderUrl,
      allowedReferers: unwrapped.allowedReferers,
      languageIso2: unwrapped.languageIso2,
      locale: unwrapped.locale,
      entryPoint: unwrapped.entryPoint,
      navigation: unwrapped.navigation,
      startParameters: unwrapped.startParameters,
      apiKey: unwrapped.apiKey,
      isDebug: unwrapped.isDebug,
      isActive: unwrapped.isActive,
      textContentScope: unwrapped.textContentScope,
    } as WidgetHostConfigDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetHostConfigModel, can not map to WidgetHostConfigDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
